module.exports = __webpack_public_path__ + "static/media/fullstack.71257bb2.jpg";